import defaultMock from '../../language_assessment/examMockConfig';

const examMockConfig = { ...defaultMock, title: 'ASSESS-597_TESTER' };

export default examMockConfig;
